module.exports = __webpack_public_path__ + "static/media/RedeemProcessing.3a1d0589.jpg";